module.exports = __webpack_public_path__ + "img/image6.a6d18ab8.png";